import { PROPERTY_TYPES } from './drmTypes'

export enum BUYBACK_FIELD {
  PropertyId = 'propertyId',
  PriceEstimateId = 'priceEstimateId',

  PriceEstimateDate = 'priceEstimateDate',

  EstimatedPrice = 'estimatedPrice',
  PropertyPrice = 'propertyPrice',

  OfferPercentage = 'offerPercentage',
  OfferPrice = 'offerPrice',
  OfferNote = 'offerNote',

  AnnualInterestRate = 'annualInterestRate',
  AnnualInterestPrice = 'annualInterestPrice',

  HouseholdMembers = 'householdMembers',
  HouseholdIncome = 'householdIncome',
  RequestedAmount = 'requestedAmount',

  BaseCommissionAmount = 'baseCommissionAmount',
  CommissionAmount = 'commissionAmount',
  CommissionNote = 'commissionNote',

  RentalFeesPrice = 'rentalFeesPrice',
  RentalFees = 'rentalFees',
  RentalFeeId = 'id',
  RentalFeeName = 'name',
  RentalFeeAmount = 'amount',

  ProcessCosts = 'ProcessCosts',
  ProcessCostId = 'id',
  ProcessCostName = 'name',
  ProcessCostAmount = 'amount',
  ProcessCostAmountTotal = 'processCostAmountTotal',

  Debts = 'debts',
  DebtId = 'id',
  DebtName = 'name',
  DebtAmount = 'amount',
  Secured = 'secured',
  DebtAmountTotal = 'debtAmountTotal',

  DebtFee = 'fee',
  BaseDebtFeeTotal = 'baseDebtFeeTotal',
  DebtFeeTotal = 'debtFeeTotal',
  DebtFeeNote = 'debtFeeNote',

  RentDurationMonths = 'rentDurationMonths',
  RentLocalPrice = 'rentLocalPrice',
  RentBasePrice = 'rentBasePrice',
  RentPrice = 'rentPrice',
  RentTotalPrice = 'rentTotalPrice',

  UnitDisposition = 'unitDisposition',
  UnitArea = 'unitArea',
  UnitUtility = 'unitUtility',
  ConstructionType = 'constructionType', // not form field

  BuildingArea = 'buildingArea',
  BuildingLandArea = 'buildingLandArea',
  BuildingUtility = 'buildingUtility',

  Description = 'description', // not form field
  Name = 'name', // not form field
  Note = 'note',
  CalculatorVersion = 'calculatorVersion', // not form field
  CalculationId = 'calculationId', // not form field

  BaseBuybackPrice = 'baseBuybackPrice', // not form field
  BuybackPrice = 'buybackPrice',

  // Financing settings
  InvestorRate = 'investorRate',
  MarketPriceAnnualGrowth = 'marketPriceAnnualGrowth',
  MarketSaleCosts = 'marketSaleCosts',
  MarketSaleDurationMonths = 'marketSaleDurationMonths',
}

export enum BUYBACK_STEP {
  PROPERTY = 'nemovitost',
  FINANCE = 'finance',
  LIVING = 'bydleni',
  OFFER = 'nabidka',
}

export const buybackSteps = [
  { title: 'Nemovitost', content: BUYBACK_STEP.PROPERTY },
  { title: 'Finance', content: BUYBACK_STEP.FINANCE },
  { title: 'Bydlení', content: BUYBACK_STEP.LIVING },
  { title: 'Nabídka', content: BUYBACK_STEP.OFFER },
]

export type BuybackFee = {
  [BUYBACK_FIELD.RentalFeeId]: string
  [BUYBACK_FIELD.RentalFeeName]: string
  [BUYBACK_FIELD.RentalFeeAmount]: number
}

export type BuybackDebtItem = {
  [BUYBACK_FIELD.DebtId]?: string
  [BUYBACK_FIELD.DebtName]?: string
  [BUYBACK_FIELD.DebtAmount]?: number
  [BUYBACK_FIELD.Secured]?: boolean
  [BUYBACK_FIELD.DebtFee]?: number
}

export type BuybackProcessCostItem = {
  [BUYBACK_FIELD.ProcessCostId]?: string
  [BUYBACK_FIELD.ProcessCostName]?: string
  [BUYBACK_FIELD.ProcessCostAmount]?: number
  [BUYBACK_FIELD.ProcessCostAmountTotal]?: number
}

export type BuybackPayoutInput = {
  [BUYBACK_FIELD.CommissionAmount]?: number
  [BUYBACK_FIELD.BaseCommissionAmount]?: number
  [BUYBACK_FIELD.DebtAmountTotal]?: number
  [BUYBACK_FIELD.DebtFeeTotal]?: number
  [BUYBACK_FIELD.BaseDebtFeeTotal]?: number
  [BUYBACK_FIELD.ProcessCostAmountTotal]?: number
  [BUYBACK_FIELD.OfferPrice]?: number
}

export type BuybackFormValues = {
  [BUYBACK_FIELD.PropertyId]?: string
  [BUYBACK_FIELD.PriceEstimateId]?: string
  [BUYBACK_FIELD.PriceEstimateDate]?: string

  cadastralAreaCode?: number
  cadastralAreaName?: string
  propertyType?: PROPERTY_TYPES
  lvNumber?: number
  address?: string

  [BUYBACK_FIELD.EstimatedPrice]?: number
  [BUYBACK_FIELD.PropertyPrice]?: number

  [BUYBACK_FIELD.OfferPercentage]?: number
  [BUYBACK_FIELD.OfferPrice]?: number
  [BUYBACK_FIELD.OfferNote]?: string

  [BUYBACK_FIELD.AnnualInterestRate]?: number
  [BUYBACK_FIELD.AnnualInterestPrice]?: number

  [BUYBACK_FIELD.HouseholdMembers]?: number
  [BUYBACK_FIELD.HouseholdIncome]?: number
  [BUYBACK_FIELD.RequestedAmount]?: number

  [BUYBACK_FIELD.BaseCommissionAmount]?: number
  [BUYBACK_FIELD.CommissionAmount]?: number
  [BUYBACK_FIELD.CommissionNote]?: string

  [BUYBACK_FIELD.RentalFees]?: BuybackFee[]
  [BUYBACK_FIELD.RentalFeesPrice]?: number

  [BUYBACK_FIELD.Debts]?: BuybackDebtItem[]
  [BUYBACK_FIELD.DebtAmountTotal]?: number
  [BUYBACK_FIELD.DebtFeeTotal]?: number
  [BUYBACK_FIELD.BaseDebtFeeTotal]?: number

  [BUYBACK_FIELD.ProcessCosts]?: BuybackProcessCostItem[]
  [BUYBACK_FIELD.ProcessCostAmountTotal]?: number

  [BUYBACK_FIELD.RentDurationMonths]?: number
  [BUYBACK_FIELD.RentLocalPrice]?: number
  [BUYBACK_FIELD.RentBasePrice]?: number
  [BUYBACK_FIELD.RentPrice]?: number
  [BUYBACK_FIELD.RentTotalPrice]?: number

  [BUYBACK_FIELD.UnitDisposition]?: number
  [BUYBACK_FIELD.UnitArea]?: number
  [BUYBACK_FIELD.UnitUtility]?: number[]
  [BUYBACK_FIELD.ConstructionType]?: string

  [BUYBACK_FIELD.BuildingArea]?: number
  [BUYBACK_FIELD.BuildingLandArea]?: number
  [BUYBACK_FIELD.BuildingUtility]?: number[]

  [BUYBACK_FIELD.Description]?: string
  [BUYBACK_FIELD.Name]?: string
  [BUYBACK_FIELD.Note]?: string
  [BUYBACK_FIELD.CalculatorVersion]?: string
  [BUYBACK_FIELD.CalculationId]?: string

  [BUYBACK_FIELD.BaseBuybackPrice]?: number
  [BUYBACK_FIELD.BuybackPrice]?: number

  [BUYBACK_FIELD.InvestorRate]?: number
  [BUYBACK_FIELD.MarketPriceAnnualGrowth]?: number
  [BUYBACK_FIELD.MarketSaleCosts]?: number
  [BUYBACK_FIELD.MarketSaleDurationMonths]?: number
}

export const monit_vk_map = {
  1: 1, // 1+kk = VK1
  2: 1, // 1+1  = VK1
  3: 2, // 2+kk = VK2
  4: 2, // 2+1  = VK2
  5: 3, // 3+kk = VK3
  6: 3, // 3+1  = VK3
  7: 4, // 4+kk = VK4
  8: 4, // 4+1  = VK4
  // bigger units aren't officially categorized, we treat them as VK4
  9: 4, // 5+kk
  10: 4, // 5+1
  11: 4, // 5+2
  14: 4, // 6+kk
  15: 4, // 6+1
  16: 4, // 6+2
  17: 4, // 7+kk
  18: 4, // 7+1
}

// obsolete and has to be cleaned up later
export type BuybackProcessedData = {
  [BUYBACK_FIELD.PropertyId]?: string
  [BUYBACK_FIELD.PriceEstimateId]?: string
  [BUYBACK_FIELD.PriceEstimateDate]?: string
  propertyType?: PROPERTY_TYPES
  cadastralAreaCode?: number
  cadastralAreaName?: string
  lvNumber?: number
  address?: string
  [BUYBACK_FIELD.ConstructionType]?: string

  [BUYBACK_FIELD.UnitArea]: number
  [BUYBACK_FIELD.UnitDisposition]?: number
  [BUYBACK_FIELD.UnitUtility]?: number[]

  [BUYBACK_FIELD.BuildingArea]?: number
  [BUYBACK_FIELD.BuildingLandArea]?: number

  [BUYBACK_FIELD.EstimatedPrice]?: number
  [BUYBACK_FIELD.PropertyPrice]: number
  [BUYBACK_FIELD.OfferPrice]: number
  [BUYBACK_FIELD.OfferPercentage]: number
  [BUYBACK_FIELD.BuybackPrice]: number

  [BUYBACK_FIELD.DebtAmountTotal]: number
  [BUYBACK_FIELD.Debts]?: BuybackDebtItem[]

  [BUYBACK_FIELD.RentPrice]: number
  [BUYBACK_FIELD.RentTotalPrice]: number
  [BUYBACK_FIELD.RentLocalPrice]: number
  [BUYBACK_FIELD.RentDurationMonths]: number

  [BUYBACK_FIELD.AnnualInterestRate]: number

  [BUYBACK_FIELD.RentalFees]?: BuybackFee[]

  [BUYBACK_FIELD.HouseholdMembers]: number
  [BUYBACK_FIELD.HouseholdIncome]: number

  unitDispositionText: string
  unitUtilitiesText: string
  buildingUtilitiesText?: string

  payout: number

  feesTotal: number

  householdLivingMinimum: number
  rentIncomeRatio: number
  householdReserveAfterRent: number
  reserveVsMinimum: number
}
